import React from 'react'
import styled from 'styled-components'

const FooterInner = styled.div`
display: flex;
justify-content: center;

font-size: 12px;

a {
  color: inherit;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s 0s ease-out;
}

a:hover {
  opacity: 0.5;
}
`

const Footer = props => {
  return <FooterInner><footer><a href="http://mandal-art.com">mandal-art.com</a></footer></FooterInner>
}

export default Footer


// WEBPACK FOOTER //
// ./src/App/Footer.js